<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:25
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2024-06-24 14:43:21
 -->
<template>
  <div class="container">
    <head-nav-bar title="我的住院" :fixed="true" @click-left="back" />
    <div class="mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />
      <div class="kong"></div>
      <no-data v-if="nodata" />
      <div v-else class="box">
        <van-skeleton title :row="3" :loading="loading">
          <!-- <div class="label-title">住院信息</div> -->
          <van-grid border :column-num="3" class="number-card">
            <van-grid-item>
              <div class="value-box">
                <span class="number">{{ info.preTotalAmount }}</span
                ><span>元</span>
              </div>
              <div class="text-less">预交金总额</div>
            </van-grid-item>
            <van-grid-item>
              <div class="value-box">
                <span class="number">{{ info.totalAmount }}</span
                ><span>元</span>
              </div>
              <div class="text-less">总费用</div>
            </van-grid-item>
            <van-grid-item>
              <div class="value-box">
                <span class="number">{{ info.preBlance }}</span
                ><span>元</span>
              </div>
              <div class="text-less">预交金余额</div>
            </van-grid-item>
          </van-grid>
          <div class="kong"></div>

          <van-cell-group class="cell-form">
            <van-field v-model="info.inPatientNo" label="住院号：" readonly />
            <van-field v-model="info.inDays" label="住院天数：" readonly />
            <van-field v-model="info.inDate" label="入院日期：" readonly />
          </van-cell-group>
          <div class="kong"></div>

          <van-cell-group>
            <!-- <van-cell
              title="预交金缴纳"
              is-link
              size="large"
              :to="{
                path: '/user/inHospital/recharge',
                query: {
                  DiagnosisCardNo: contact.DiagnosisCardNo
                }
              }"
            >
              <span slot="icon" class="cell-icon" style="color:#07c160"
                ><van-icon name="card"
              /></span>
            </van-cell> -->
            <van-cell
              title="住院费用汇总"
              is-link
              size="large"
              :to="{
                path: '/user/inHospital/detailed',
                query: {
                  DiagnosisCardNo: contact.diagnosisCardNo,
                  InpatientId: info.inpatientId,
                  InDate: info.inDate,
                },
              }"
            >
              <span slot="icon" class="cell-icon" style="color:#1989fa"
                ><van-icon name="label"
              /></span>
            </van-cell>
            <van-cell
              title="住院信息"
              is-link
              size="large"
              :to="{
                path: '/user/inHospital/summary',
                query: {
                  DiagnosisCardNo: contact.diagnosisCardNo,
                  InPatientNo: info.inPatientNo,
                },
              }"
            >
              <span slot="icon" class="cell-icon" style="color:#1989fa"
                ><van-icon name="label"
              /></span>
            </van-cell>
            <van-cell
              v-if="sysParams && sysParams.enabledMobileInHospitalReport"
              title="住院报告"
              is-link
              size="large"
              :to="{
                path: '/user/inHospital/hospitalizationReport',
                query: {
                  DiagnosisCardNo: contact.diagnosisCardNo,
                  InpatientId: info.inpatientId,
                },
              }"
            >
              <span slot="icon" class="cell-icon" style="color:#1989fa"
                ><van-icon name="label"
              /></span>
            </van-cell>
          </van-cell-group>
        </van-skeleton>
      </div>
    </div>
    <van-button
      v-if="!nodata && EnabledInHospitalRecharge"
      type="info"
      class="deposit"
      @click="showDeposit = true"
      >住院押金</van-button
    >
    <van-popup v-model="showDeposit" position="bottom">
      <div class="show-deposit-popup">
        <div class="title">填写押金金额</div>
        <div class="number-box">
          <button
            v-for="item in moneyArray"
            :key="item"
            @click="deposit = item"
          >
            {{ item }}
          </button>
        </div>
        <van-field
          v-model="deposit"
          label="押金金额"
          placeholder="请输入支付押金金额"
          class="deposit-input"
          type="number"
        />
        <van-button class="pay" @click="toPay" :loading="payLoading"
          >支付</van-button
        >
      </div>
    </van-popup>
    <form ref="form" method="post" name="auto_submit_form" :action="payAction">
      <input
        v-for="item in payParams"
        :key="item.Key"
        type="hidden"
        :name="item.key"
        :value="item.value || ' '"
      />
      <input
        type="submit"
        value="立刻提交"
        style="display:none"
        name="name"
        id="name"
      />
    </form>
    <action-sheet v-model="show" :actions="payMethod" @select="onSelect" />
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Button,
  Popup,
  Checkbox,
  Dialog,
  Field,
  Grid,
  GridItem,
  Icon,
  Skeleton,
  ActionSheet,
  Toast,
  Notify,
} from "vant";
import ContactCard from "@/components/ContactCard";
import NoData from "@/components/NoData";
import wx from "weixin-jsapi";
import { cache } from "@/utils/common";
import weChatPayBeforeMixin from "@/mixins/weChatPayBeforeMixin";
export default {
  name: "Confirm",
  mixins: [weChatPayBeforeMixin],
  components: {
    ActionSheet,
    ContactCard,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Skeleton.name]: Skeleton,
    [Dialog.Component.name]: Dialog.Component,
    NoData,
  },
  data() {
    return {
      payParams: [],
      payMethod: [],
      payAction: "",
      show: false,
      visible: {
        agreement: false,
      },
      info: {
        typeName: "12",
      },
      checked: false,
      contact: {},
      showList: false,
      nodata: false,
      loading: true,
      payLoading: false,
      showDeposit: false,
      deposit: "",
      moneyArray: [500, 1000, 2000, 3000, 4000, 5000],
      EnabledInHospitalRecharge: false,
      sysParams: {},
    };
  },
  watch: {
    contact(e) {
      console.log(e);
      if (e && e.diagnosisCardNo) {
        this.getInfo(e.diagnosisCardNo);
      }
    },
    showDeposit(tyoe) {
      if (!tyoe) {
        this.deposit = null;
      }
    },
  },
  created() {
    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      this.sysParams = res.data;
    });
    this.onPayPageInit();
  },
  methods: {
    onPayPageInitBefore() {
      return new Promise(resolve => {
        resolve();
      });
    },
    onPayPageInit() {
      this.onPayPageInitBefore().then(() => {
        this.$post("Common_SelectData", { Code: "MobilePayMethodDic" }).then(
          res => {
            res.data.MobilePayMethodDic.map(item => {
              this.payMethod.push({
                name: item.text,
                ...item,
              });
            });
          },
        );
        this.$post("GetWxSystemParameterInfo", {}).then(res => {
          this.EnabledInHospitalRecharge = res.data.enabledInHospitalRecharge;
        });
      });
    },
    getInfo(id) {
      this.$post("InHospital_Info", {
        DiagnosisCardNo: id,
      })
        .then(res => {
          this.info = res.data;
          let isPay = cache.get("isPay");
          cache.set("isPay", "empty");
          if (isPay == "pay") {
            this.onSubmitPayAfter();
          } else {
            if (!this.info.inPatientNo) {
              this.nodata = true;
            } else {
              this.nodata = false;
              this.loading = false;
            }
          }
        })
        .catch(() => {
          this.nodata = true;
        })
        .finally(() => {});
    },

    onContactChange() {
      console.log(this.contact);
    },
    toPay() {
      if (!this.deposit) {
        Toast.fail("请输入金额");
      } else {
        if (this.payMethod.length == 1) {
          this.onSelect(this.payMethod[0]);
        } else {
          this.show = true;
          return;
          //这里做支付处理
        }
        this.payLoading = true;
      }
    },
    onSelect(item) {
      this.show = false;
      const params = {
        Id: this.info.inpatientId + "",
        cardholderName: this.info.patientName,
        diagnosisCardNo: this.info.diagnosisCardNo,
        payType: "3",
        payMethod: item.value,
        amount: this.deposit,
      };
      this.onWeChatPayBefore(params).then(() => {
        this.$post("Pay_Wechat", params).then(res => {
          this.payLoading = false;
          this.setWxConfig(res.data);
        });
      });
    },
    setWxConfig(option) {
      const that = this;
      if (option.apiUrl) {
        this.payAction = option.apiUrl;
        this.payParams = option.params.map(item => {
          item.value.replace('"', "&quot;");
          return item;
        });
        this.$nextTick(() => {
          this.$refs.form.submit();
        });
      } else {
        wx.config({
          debug: false, //这里一般在测试阶段先用true，等打包给后台的时候就改回false,
          appId: option.appId,
          timestamp: option.timeStamp,
          nonceStr: option.nonceStr,
          signature: option.paySign,
          jsApiList: ["chooseWXPay"],
        });
        wx.ready(function() {
          wx.checkJsApi({
            jsApiList: ["chooseWXPay"],
            success: function(res) {
              console.log(res, "seccess");
            },
            fail: function(res) {
              console.log(res, "fail");
            },
          });
          that.jsApiCall(option);
        });
      }
    },
    jsApiCall(option) {
      const _this = this;
      wx.ready(function() {
        wx.chooseWXPay({
          appId: option.appId,
          timestamp: option.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: option.nonceStr, // 支付签名随机串，不长于 32
          package: option.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: option.paySign, // 支付签名
          success: function() {
            //跳转到支付成功页面有这个页面
            _this.onSubmitPayAfter();
          },
          cancel: function(res) {
            console.log(res);
            //取消支付
            // _this.$router.push({
            //   name: "servePreOrderResult",
            //   query: { Id: _this.Id }
            // });
          },
          fail: function(res) {
            console.log(res);
            Toast.fail("支付失败，请重试");
          },
        });
      });
    },
    onSubmitPayAfter() {
      Notify({ background: "rgb(7,193,96)", message: "支付成功" });
      this.showDeposit = false;
      this.getInfo(this.info.diagnosisCardNo);
    },
    back() {
      this.$router.push({
        name: "userIndex",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.text {
  font-size: 0.35rem;
  line-height: 2;
  padding: 0.5rem 0.3rem;
  max-height: 8rem;
  overflow-y: auto;
  color: #555;
}
.number-card {
  font-size: 0.3rem;
  .value-box {
    .number {
      font-size: 0.5rem;
      color: @main-color;
    }
  }
}
.cell-form {
  /deep/.van-field__label {
    width: 70px;
    margin-right: 0;
  }
}
.deposit {
  width: 90%;
  border-radius: 5px;
  margin-left: 5%;
  position: fixed;
  bottom: 15px;
}
.deposit-input {
  font-size: 18px;
  /deep/.van-field__body {
    font-weight: bold;
    font-size: 20px;
  }
}
.show-deposit-popup {
  font-size: 16px;
  padding: 4%;
  .title {
    widows: 100%;
    padding: 10px 0;
    text-align: center;
    margin-bottom: 10px;
  }
  .number-box {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-bottom: 10px;
    button {
      width: 30%;
      background-color: rgb(25, 137, 250);
      color: #fff;
      padding: 4% 0;
      text-align: center;
      border-radius: 5px;
      border: none;
    }
    button:nth-child(1),
    button:nth-child(2),
    button:nth-child(4),
    button:nth-child(5) {
      margin-right: 5%;
    }
    button:nth-child(1),
    button:nth-child(2),
    button:nth-child(3) {
      margin-bottom: 3%;
    }
  }
  .pay {
    background-color: rgb(25, 137, 250);
    width: 100%;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
  }
}
</style>
